import Dropzone from "dropzone";
import "dropzone/dist/dropzone.css";

Dropzone.autoDiscover = false;

$(document).on("turbolinks:load", function() {
  $(".dropzone-uploader").each(function() {
    const $dropzone = $(this);
    const $fileInput = $dropzone.find(".dropzone-file-input");
    const $removedImage = $dropzone.find(".removed-image");
    const savedImage = $dropzone.data("saved-image");
    const imageId = $dropzone.data("image-id");

    const dropzone = new Dropzone(this, {
      url: "/",
      autoProcessQueue: false,
      maxFiles: 1,
      clickable: true,
      acceptedFiles: 'image/*',
      addRemoveLinks: false,
      previewsContainer: this,
      dictDefaultMessage: "",
      previewTemplate: `
        <div class="dz-preview dz-file-preview">
          <div class="dz-details">
            <div class="dz-thumbnail">
              <img data-dz-thumbnail />
            </div>
            <div class="dz-remove" data-dz-remove>Remove file</div>
          </div>
        </div>
      `,
      init: function() {
        // Add message only to this dropzone
        const messageHtml = `
          <div class="dz-message text-center">
            <div class="browse-files-button">
              + Browse Files
            </div>
            <div style="font-size: 10px; color: #777; margin-top: 8px;">
              File types: JPG, PNG (Max 5MB)
            </div>
            <div class="upload-text mt-2" style="font-size: 17px; color: #555;">or drag and drop files here</div>
          </div>
        `;
        $dropzone.append(messageHtml);
            
        if (savedImage) {
          const mockFile = {
            name: "existing.jpg",
            size: 1,
            accepted: true
          };
          this.emit("addedfile", mockFile);
          this.emit("thumbnail", mockFile, savedImage);
          this.emit("complete", mockFile);
          this.files.push(mockFile);
          $dropzone.find(".dz-message").hide();
        }

        // Scope events to this dropzone only
        this.on("addedfile", function(file) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(file);
          $fileInput[0].files = dataTransfer.files;
          $dropzone.find(".dz-message").hide();
        });

        this.on("removedfile", function(file) {
          $fileInput.val("");
          $removedImage.val("true");
          $dropzone.find(".dz-message").show();

          if (imageId) {
            $.ajax({
              url: `/remove_attachment/${imageId}`,
              type: "DELETE",
              headers: {
                "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
              }
            });
          }
        });
      }
    });
  });
});